module.exports = __webpack_public_path__ + "static/media/pic-news.32bcab17.webp";